/* eslint-disable no-undef */
// This file configures the initialization of Sentry on the server.
// The config you add here will be used whenever the server handles a request.
// https://docs.sentry.io/platforms/javascript/

// eslint-disable-next-line import/no-extraneous-dependencies
Sentry.onLoad(() => {
  Sentry.init({
    denyUrls: [
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,

      // third party scripts
      /connect\.facebook\.net/i,
      /\.smartlook\.(com|cloud)/i,
      /bat\.bing\.com/i,
      /snap\.licdn\.com/i,
      /google-analytics\.com/i,
      /googletagmanager\.com\//i,
      /widget\.trustpilot\.com/i,
      /script\.tapfiliate\.com/i,
      /\.g\.doubleclick\.net/i,
      /\.clickcease\.com/i,
      /\.ads\.linkedin\.com/i,
      /\.googleapis\.com/i,
      /localhost/i,
    ],
    environment: window.siteInfo.mode === 'live' ? 'production' : 'development',
    release: process.env.GCP_VERSION_NAME,
  });
});
